import React from 'react';
import isTelegram from './isTelegram';

const AddButton = ({ id, admin_tg, addProduct }) => {
  const handleClick = () => {
    console.log(window.Telegram.WebApp.headerColor)
    if (isTelegram) {
      // If Telegram.WebApp is available, perform this action
      addProduct(id);
    } else {
      // If Telegram.WebApp is not available, redirect to the specified URL
      window.location.href = 'https://t.me/' + admin_tg;
    }
  };

  return (
    <button className="Button" style={{fontSize: '1.2rem'}} onClick={handleClick}>
      &nbsp;+&nbsp;
    </button>
  );
};

export default AddButton;
